<app-base-send-status-statistics
[title]="title"
[getMonthlyItemsApiMethodName]="getMonthlyItemsApiMethodName"
[getDailyItemsApiMethodName]="getDailyItemsApiMethodName"
[isShowOrganizationDropDown]="true"
[isShowUserDropDown]="true"
[doughnutChartId]="doughnutChartId"
[barChartId]="barChartId"
[userType]="userType"
[isAdminStats]="true"
>
</app-base-send-status-statistics>
